import '@/assets/css/index.postcss'
import '@/assets/css/tailwind.scss'
import '@/assets/css/styles.scss'
import '#/css/antd-custom.less'

import 'proxy-polyfill'

import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Antd from 'ant-design-vue'

import SparkButton from '#/components/generic/SparkButton/SparkButton.vue'
import Loader from '@/components/generic/Loader.vue'
import SparkIcon from '#/components/generic/SparkIcon/index.vue'
import SparkTabs from '@/components/generic/SparkTabs.vue'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import duration from 'dayjs/plugin/duration'

import { router } from '@/router'

dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(duration)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

window.Office.onReady(() => {
  const app = createApp(App)

  // Register global components
  app.component('SparkButton', SparkButton)
  app.component('Loader', Loader)
  app.component('SparkIcon', SparkIcon)
  app.component('SparkTabs', SparkTabs)

  // Use plugins
  app.use(pinia)
  app.use(Antd)
  app.use(router)

  app.mount('#app')
})
